import { Component, DestroyRef, OnInit } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';
import { CommunicationChartPanelStore } from '@app/pages/constructor/constructor-components/communication-chart/store/communication-chart-panel.store';
import { MessageNotificationViewModel } from '@app/pages/constructor/constructor-components/communication-chart/models/message-notification-view.model';

@Component({
  selector: 'app-communication-chart-alert',
  imports: [NgClass, DatePipe, RouterLink, TranslatePipe],
  templateUrl: './communication-chart-alert.component.html',
  styleUrl: './communication-chart-alert.component.scss'
})
export class CommunicationChartAlertComponent implements OnInit {
  public isAlertNotification = true;

  public messagesListAlert: MessageNotificationViewModel[] = [];

  constructor(
    private communicationChartPanelStore: CommunicationChartPanelStore,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.streamCommunicationChartAlert();
  }

  private streamCommunicationChartAlert(): void {
    this.communicationChartPanelStore.commentsChartsAlert$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data?.length) {
          data.forEach(newNotification => {
            if (
              !this.messagesListAlert.some(
                msg => msg.userId === newNotification.userId
              )
            ) {
              this.messagesListAlert = [
                ...this.messagesListAlert,
                newNotification
              ];

              timer(3000).subscribe(() => {
                this.removeCommunicationChart(newNotification.userId);
              });
            }
          });
        }
      });
  }

  private removeCommunicationChart(id: string): void {
    const index = this.messagesListAlert.findIndex(
      message => message.userId === id
    );

    if (index > -1) {
      this.messagesListAlert[index].hidden = true;

      timer(500).subscribe(() => {
        this.messagesListAlert = this.messagesListAlert.filter(
          message => message.userId !== id
        );
      });
    }
  }
}
